import { render, staticRenderFns } from "./StockCredit.vue?vue&type=template&id=709864d2&scoped=true&"
import script from "./StockCredit.vue?vue&type=script&lang=js&"
export * from "./StockCredit.vue?vue&type=script&lang=js&"
import style0 from "./StockCredit.vue?vue&type=style&index=0&id=709864d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709864d2",
  null
  
)

export default component.exports